import React, { ReactNode } from 'react';

import { ErrorCard } from 'components/Cards/ErrorCard';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: { name: '', message: '', stack: '' },
    };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  render(): ReactNode {
    const { hasError, error } = this.state;
    const { children } = this.props;

    return hasError ? (
      <ErrorCard title="Error" details={error.message} />
    ) : (
      children
    );
  }
}
